import { render, staticRenderFns } from "./PlanSummary.vue?vue&type=template&id=54fe5265&scoped=true"
import script from "./PlanSummary.vue?vue&type=script&lang=js"
export * from "./PlanSummary.vue?vue&type=script&lang=js"
import style0 from "./PlanSummary.vue?vue&type=style&index=0&id=54fe5265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe5265",
  null
  
)

export default component.exports